// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"965":"e622e1fd","2444":"2cc9d25e","3140":"2cc9d25e","4226":"2cc9d25e","8448":"2cc9d25e","8921":"2cc9d25e"}[chunkId] + ".chunk.css";
};